// Rótulos das modalidades e das propulsões no idioma do painel (#433).
//
// O slug é a chave e nunca traduz. O `label` de `lib/sportCatalog.ts` segue
// sendo o rótulo canônico em português, espelho do Dart e do C#; este arquivo
// é só a EXIBIÇÃO. As traduções são as mesmas do app (`sport*` e
// `sportPropulsion*` em `mobile/lib/l10n/app_{pt,en,es}.arb`): em inglês e
// espanhol, "Bidirecional" é "Twintip", que é como o esporte chama a prancha.
//
// O `satisfies` amarra as chaves ao catálogo: esporte novo em `SPORT_CATALOG`
// sem rótulo aqui não compila.
import type { SportPropulsionId, SportSlug } from '../../lib/sportCatalog';
import { defineMessages } from '../core';

export const sportsT = defineMessages('sports', {
  pt: {
    labels: {
      kitesurf: 'Bidirecional',
      kite_wave: 'Wave',
      kite_foil: 'Hydrofoil',
      wing_foil: 'Wing Foil',
      parawing_foil: 'Parawing Foil',
      windsurf: 'Windsurf',
      sailing_canoe: 'Canoa à Vela',
      catamaran: 'Catamarã',
      sup: 'SUP',
      sup_foil: 'SUP Foil',
      surfski: 'Surfski',
      outrigger: 'Canoa Havaiana',
      paddleboard: 'Paddleboard',
    } satisfies Record<SportSlug, string>,
    propulsions: {
      kite: 'Kite',
      wing: 'Wing',
      sail: 'Vela',
      paddle: 'Remo',
    } satisfies Record<SportPropulsionId, string>,
  },
  en: {
    labels: {
      kitesurf: 'Twintip',
      kite_wave: 'Wave',
      kite_foil: 'Hydrofoil',
      wing_foil: 'Wing Foil',
      parawing_foil: 'Parawing Foil',
      windsurf: 'Windsurf',
      sailing_canoe: 'Sailing Canoe',
      catamaran: 'Catamaran',
      sup: 'SUP',
      sup_foil: 'SUP Foil',
      surfski: 'Surfski',
      outrigger: 'Outrigger Canoe',
      paddleboard: 'Paddleboard',
    },
    propulsions: {
      kite: 'Kite',
      wing: 'Wing',
      sail: 'Sail',
      paddle: 'Paddle',
    },
  },
  es: {
    labels: {
      kitesurf: 'Twintip',
      kite_wave: 'Wave',
      kite_foil: 'Hydrofoil',
      wing_foil: 'Wing Foil',
      parawing_foil: 'Parawing Foil',
      windsurf: 'Windsurf',
      sailing_canoe: 'Canoa a Vela',
      catamaran: 'Catamarán',
      sup: 'SUP',
      sup_foil: 'SUP Foil',
      surfski: 'Surfski',
      outrigger: 'Canoa Hawaiana',
      paddleboard: 'Paddleboard',
    },
    propulsions: {
      kite: 'Kite',
      wing: 'Wing',
      sail: 'Vela',
      paddle: 'Remo',
    },
  },
});
